import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Dow from './Dow.js';
import SP500 from './SP500.js';
import Nasdaq from './Nasdaq.js';
//import GainerLooser from './GainerLooser.js';
//import Commodities from './Commodities.js';
import StockNews from '../news/StockNews';
import EarningCalender from './EarningCalender.js';
import IPOCalender from './IPOCalender.js';
import SectorPerformanceChart from './SectorPerformanceChart.js';
import AdvanceDeclineChart from './AdvanceDeclineChart.js';
import Actives from './Actives.js';
import DisplayStockPrice from './DisplayStockPrice.js';
//import IndexSignals from './IndexSignals';
//import StockSignals from './StockSignals';
import InsiderTrading from '../insider/InsiderTrading';
import { Helmet } from "react-helmet";
import EconomicCalender from './EconomicCalender';
import StockDividendCalender from './StockDividendCalender.js';
import StockSplitCalender from './StockSplitCalender';
import MediaQuery from 'react-responsive';
// import GenericChart from './GenericChart';
import ATSWeeklyTotal from '../ats/ATSWeeklyTotal';
//import PrePostStockPrice from './PrePostStockPrice';
import Gainers from './Gainers';
import Loosers from './Loosers';
//import HighLowsWrap from './HighLowsWrap';
import MixHigh from './MixHigh';
import MixLow from './MixLow';
// import TreeMap from './TreeMap';
import Paypal from './Paypal';
import StockUpgradeDowngradeFull from '../upgradeDowngrade/StockUpgradeDowngradeFull';
import StockSenateTradingFull from '../senateTrading/StockSenateTradingFull';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabOption: 'indices',
      reload: false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    //this.interval = setInterval(() => window.location.reload(false), 1000 * 10 * 10); //10 mins
    this.interval = setInterval(() => { this.setState({ reload: true }) }, 1000 * 10 * 15); //15 mins
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    if (this.state.reload) {
      console.log('Dashboard Reloading...');
      this.setState({ reload: false });
      return (<div>Loading...</div>);
    }
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <link rel="canonical" href="https://www.vizfm.com" />
          <title>Financial Market Visualization</title>
          {/* <meta name="description" content="Stock Charts, Algorithmic trading, Insider, News, Earning Release, Dashboard" /> */}
          <meta
            name="description"
            content="Financial Market Visualization, Algo (Algorithmic) trading, Daily and Intraday Charts.  Algorithmic trading signal, Stock Algo Signal Indicators, Support and Resistance, Free stock screener, S&P 500 HeatMap, Sector Performance, Alternative Trading System (ATS) Dark Pool, Index screener, Crypto Screener, Forex Screener, Commodities Screener, ETF Screener, Mutualfund screener, Latest News, Looser Gainer Active, Insider Trading, Institutional Holdings, Earning Release Calender, Economic Events Calender, Stock Dividend Calender, Stock split calender, IPO Calender, Dashboard"
          />
        </Helmet>

        <Container fluid className="p-2">
          <Row>
            {/* <Tabs defaultActiveKey={this.state.tabOption} id="uncontrolled-tab-example" className="mb-3">
              <Tab eventKey="indices" title="Indices">
                <Row> */}
            <Col>
              <Row><Col><DisplayStockPrice symbolName={'DOW'} ticker={'^DJI'} /></Col></Row>
              {/* <Row><Col><PrePostStockPrice symbolName={'DIA'} ticker={'DIA'} /></Col></Row> */}
              <Row><Col><Dow /></Col></Row>
            </Col>
            <Col>
              <Row><Col><DisplayStockPrice symbolName={'S&P 500'} ticker={'^GSPC'} /></Col></Row>
              <Row><Col><SP500 /></Col></Row>
            </Col>
            <Col>
              <Row><Col><DisplayStockPrice symbolName={'NASDAQ'} ticker={'^IXIC'} /></Col></Row>
              <Row><Col><Nasdaq /></Col></Row>
            </Col>
            {/* <Col>
                    <Row><Col><DisplayStockPrice symbolName={'Russell2K'} ticker={'^RUT'} /></Col></Row>
                    <Row><Col><GenericChart symbol={'^GSPC'} interval={'15min'} /></Col></Row>
                  </Col>                   */}
            <Col>
              {/* <Row><Col></Col></Row> */}
              {/* <Row><Col><Commodities /></Col></Row> */}
              <Row><Col><AdvanceDeclineChart /></Col></Row>
              {/* <Row><Col><IndexSignals /></Col></Row>  */}
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
              <MediaQuery minWidth={501}>
                <StockNews limit={32} />
              </MediaQuery>
              <MediaQuery maxWidth={500}>
                <StockNews limit={5} />
              </MediaQuery>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
              {/* <Row>
                <Col><TreeMap /></Col>
              </Row>   */}
              {/* <Row>
                <Col><IndexSignals /></Col>
             </Row>  */}
             <Row>
                <Col><Paypal /></Col>
              </Row>
              <Row>
                <Col><SectorPerformanceChart /></Col>
                <Col><Actives /></Col>
              </Row>
              <Row>
                <Col><Gainers /></Col>
                <Col><Loosers /></Col>
              </Row>
              <Row>
                {/* <Col><HighLowsWrap/></Col> */}
                <Col><MixHigh /></Col>
                <Col><MixLow /></Col>
              </Row>  
              <Row>
                <Col><EconomicCalender /></Col>
              </Row>
              <Row>
                <Col><EarningCalender /></Col>
              </Row>
              <Row>
                <Col><StockDividendCalender /></Col>
              </Row>
              <Row>
                <Col><IPOCalender limit={10} /></Col>
              </Row>
              <Row>
                <Col><StockSplitCalender /></Col>
              </Row>
              <Row>
                <Col><InsiderTrading symbol={''} limit={5} /></Col>
              </Row>
              <Row>
                <Col><ATSWeeklyTotal /></Col>
              </Row>
              <Row>
                <Col><StockUpgradeDowngradeFull symbol={''} limit={5} /></Col>
              </Row>
              <Row>
                <Col><StockSenateTradingFull symbol={''} limit={5} /></Col>
              </Row>

            </Col>
          </Row>

          <Row>
            <Col style={{ textAlign: 'left', fontSize: '1' }}>
              <small>&nbsp;* - Trade signals are based on Algorithm and please do your analysis before any trades.  Always remember to put your stop to minimize your loss incase it goes in the opposite direction.</small>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Dashboard;
